<template>
    <div>
        <a-spin :spinning="spinning" tip="分析中请稍等，时间可能有点长，请您耐心等待...">
        <div class="vote-index">
            <div class="page-title">
                投稿分析

                <div class="desc" style="font-size:15px">
                    <a-tooltip placement="bottomRight">
                        <template #title>
                            <div >投稿分析是基于图情期刊历史发表的论文建立期刊语料库，利用机器学习算法，将待投稿论文与期刊语料库进行相似度计算，进而给出目标期刊的推荐指数及分析报告，为作者选择目标期刊进行论文投递时提供决策参考，提高投稿效率。推荐指数的百分比仅反映待投稿论文与图情期刊选题的匹配度，并不代表论文被期刊录入的成功率。</div>
                        </template>
                        <question-circle-outlined />什么是投稿分析？
                    </a-tooltip>
                    
                </div>
            </div>

            <div class="page-main">
                <div class="title">信息录入</div>
                <div class="form">
                    <a-row :gutter="[16,16]">
                        <a-col :span="4">
                            <div class="label"><span class="red">*</span>论文标题</div>
                        </a-col>
                        <a-col :span="20">
                            <a-input v-model:value.trim="title" />
                        </a-col>
                    </a-row>
                    <div class="blank"></div>
                    <a-row :gutter="[16,16]">
                        <a-col :span="4">
                            <div class="label"><span class="red">*</span>论文关键词</div>
                        </a-col>
                        <a-col :span="20">
                            <a-input v-model:value.trim="keywords" />
                        </a-col>
                    </a-row>
                    <div class="blank"></div>
                    <a-row :gutter="[16,16]">
                        <a-col :span="4">
                            <div class="label"><span class="red">*</span>论文摘要</div>
                        </a-col>
                        <a-col :span="20">
                            <a-textarea
                            v-model:value.trim="summary"
                            :auto-size="{ minRows: 11, maxRows: 11 }"
                            />
                        </a-col>
                    </a-row>
                </div>
                <div class="btns">
                    <a-button  @click="reset">重置</a-button>
                    <a-button type="primary" @click="voteAnalysis">投稿分析</a-button>
                </div>
            </div>
        </div>
        </a-spin>
    </div>
</template>

<script>
import { defineComponent,onMounted,reactive, toRefs } from "vue";
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import Http from "../../until/http";
import { messageTips, setSessionItem } from "../../until/tools";
import { useRouter } from "vue-router";
import config from "../../until/configs";
export default defineComponent({
    components:{QuestionCircleOutlined},
    setup() {

        const state = reactive({
            title: '',
            keywords: '',
            summary: '',
            spinning:false
        });

        const router = useRouter();

        const voteAnalysis = () => {
            if(state.title==='') {
                messageTips('请输入论文标题',2);
                return false;
            }
            if(state.title.length>60) {
                messageTips('请将论文标题限制在60个字以内',2);
                return false;
            }
            if(state.keywords==='') {
                messageTips('请输入论文关键词',2);
                return false;
            }
            if(state.summary==='') {
                messageTips('请输入摘要',2);
                return false;
            }
            Object.assign(state,{spinning:true});
            let params = {
                title:state.title,
                keywords:state.keywords,
                summary:state.summary
            }
            Http.voteAnalysis(params).then(res=>{
                if(res) {
                    if(res.success) {
                        Http.voteAnalysisInfo(params).then(data=>{
                            Object.assign(state,{spinning:false});
                            if(data&&data.success) {
                                setSessionItem('voteCondition',params);
                                setSessionItem('journalList',data.journalList);
                                messageTips(data.message,3);
                                setTimeout(()=>{
                                    router.push('/voteResult');
                                },500);
                            }else{
                                if(data&&data.notShow){
                                    messageTips(data.message,2);
                                }
                            }
                        });
                    } else {
                        messageTips(res.message,2);
                        Object.assign(state,{spinning:false});
                    }
                } else {
                    Object.assign(state,{spinning:false});
                }
            });
        }

        const reset = ()=>{
            Object.assign(state,{
                title:'',
                keywords:'',
                summary:''
            })
        }

        onMounted(()=>{
            document.title = '投稿分析-'+config.siteTitle;
        });

        return  {
            ...toRefs(state),
            voteAnalysis,
            reset
        }
    }
})
</script>

<style lang="scss" scoped>
@import '../../scss/vote-index.scss';
</style>